import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enUSTranslation from "./enUS/translation.json";
import esTranslation from "./es/translation.json";
import itTranslation from "./it/translation.json";
import frTranslation from "./fr/translation.json";
import esUSTranslation from "./esUS/translation.json";
import frCATranslation from "./frCA/translation.json";
import deTranslation from "./de/translation.json";
import nlTranslation from "./nl/translation.json";

import enUS_LCF402 from "./enUS/lcf402.json";

import enUS_BXLH from "./enUS/bxlh.json";

import { DEFAULT_LOCALE } from "./helpers";

const resources = {
  "en-US": {
    translation: {
      ...enUSTranslation,
      ...enUS_BXLH,
      ...enUS_LCF402,
    },
  },
  es: {
    translation: { ...esTranslation },
  },
  it: {
    translation: {
      ...itTranslation,
    },
  },
  fr: {
    translation: {
      ...frTranslation,
    },
  },
  "es-US": {
    translation: {
      ...esUSTranslation,
    },
  },
  "fr-CA": {
    translation: { ...frCATranslation },
  },
  de: {
    translation: { ...deTranslation },
  },
  nl: {
    translation: { ...nlTranslation },
  },
};

// For more info about this configuration check https://react.i18next.com/latest/using-with-hooks
i18n
  // pass the i18n instance to react-i18next .
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: DEFAULT_LOCALE,
    debug: false,
    keySeparator: false,
  });

export default i18n;
